import { inject } from 'vue';
import { meKey } from '/codebuild/output/src2081543335/src/cocoo_gov/src/utils/injectionKey.js';
const __default__ = {
  data() {
    return {
      school: {}
    };
  },
  methods: {
    handleLogout() {
      this.$auth.logout({
        returnTo: window.location.origin
      });
    }
  }
};
export default /*#__PURE__*/Object.assign(__default__, {
  __name: 'AppHeader',
  setup(__props) {
    const me = inject(meKey);
    return {
      __sfc: true,
      me
    };
  }
});